import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { border } from '@metro-ui/tokens/js';
import { responsiveProp, responsivePropTypes, } from '../utils/responsiveProp';
import { Layout } from '../Layout';
import { getBorderColor } from './tokens';
export * from './components/SegmentedControlOption';
export * from './components/SegmentedLabel';
export var SegmentedControl = styled(React.forwardRef(function (_a, ref) {
    var _b = _a.direction, direction = _b === void 0 ? 'row' : _b, _c = _a.textAlign, textAlign = _c === void 0 ? 'center' : _c, id = _a.id, name = _a.name, _d = _a.value, value = _d === void 0 ? '' : _d, onChange = _a.onChange, isDisabled = _a.isDisabled, hasError = _a.hasError, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["direction", "textAlign", "id", "name", "value", "onChange", "isDisabled", "hasError", "className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { id: id, role: "radiogroup" }),
        React.createElement(Layout, { direction: direction, className: className, ref: ref }, React.Children.map(children, function (child) {
            var element = child;
            if (React.isValidElement(element)) {
                element = React.cloneElement(element, {
                    name: name,
                    onChange: onChange,
                    isChecked: element.props.value === value,
                    textAlign: element.props.textAlign || textAlign,
                    direction: direction,
                    isDisabled: element.props.isDisabled || isDisabled,
                    hasError: hasError,
                });
            }
            return element;
        }))));
}))(function (_a) {
    var hasError = _a.hasError, isDisabled = _a.isDisabled, direction = _a.direction;
    var borderColor = getBorderColor({ hasError: hasError, isDisabled: isDisabled });
    var borderWidths = function (direction2D) {
        var thin = border.width.thin;
        if (direction2D === 'column')
            return thin + " 0 " + thin + " 0";
        return "0 " + thin + " 0 " + thin;
    };
    var colors = function (direction2D, start, end) {
        if (direction2D === 'column')
            return (start ? borderColor : 'transparent') + " transparent " + (end ? borderColor : 'transparent') + " transparent";
        return "transparent " + (end ? borderColor : 'transparent') + " transparent " + (start ? borderColor : 'transparent');
    };
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: ", ";\n    overflow: hidden;\n    position: relative;\n\n    border: ", " solid ", ";\n\n    /* avoid gaps between borders when zooming */\n    background-color: ", ";\n\n    /* Separator between options */\n    ", "\n  "], ["\n    border-radius: ", ";\n    overflow: hidden;\n    position: relative;\n\n    border: ", " solid ", ";\n\n    /* avoid gaps between borders when zooming */\n    background-color: ", ";\n\n    /* Separator between options */\n    ", "\n  "])), border.radius.medium, border.width.thin, borderColor, borderColor, responsiveProp(direction, 'row', function (val) {
        return val &&
            "\n    .mds-segmented-control-option {\n      border: solid transparent;\n      border-width: " + borderWidths(val) + ";\n\n      :not(&-isChecked) + :not(&-isChecked) {\n        border-color: " + colors(val, true, false) + ";\n      }\n      \n      &-isChecked {\n        border-color: " + colors(val, true, true) + ";\n      }\n    }";
    }));
});
SegmentedControl.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    hasError: PropTypes.bool,
    direction: responsivePropTypes(PropTypes.oneOf(['column', 'row'])),
    textAlign: PropTypes.oneOf(['center', 'left', 'right', 'justify']),
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=SegmentedControl.js.map